exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reviews-rating[data-v-5f3bd825] {\n  display: flex;\n  align-items: baseline;\n  margin-top: 10px;\n  margin-left: -5px;\n}\n.reviews-rating-count[data-v-5f3bd825] {\n  font-size: 20px;\n  margin-left: 10px;\n}\n@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {\n.reviews-rating[data-v-5f3bd825] {\n    margin-bottom: 15px;\n}\n}", ""]);

// exports
